import { useMemo } from 'react'
import { useUploadManager } from '@design-stack-vista/upload-components'
import { SelectedAsset } from '../store/types'
import { useSchemeImages } from './useSchemeImages'

interface UseSchemeImagesResult {
  uploads: SelectedAsset[]
}

export const useSchemeUploads = (schemeId: string): UseSchemeImagesResult => {
  const { images } = useSchemeImages(schemeId)
  const { assetStore } = useUploadManager()

  const uploads = useMemo<SelectedAsset[]>(() => {
    const assets = assetStore?.assets || []

    return images
      .map(({ image }) => {
        const matchingAsset = assets.find((asset) => image.sherbertAssetId === asset.data?.id)

        return matchingAsset
          ? {
              asset: matchingAsset,
              pageNumber: 1,
            }
          : null
      })
      .filter((item): item is SelectedAsset => item !== null)
  }, [assetStore?.assets, images])

  return {
    uploads,
  }
}
